var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElevation = function SvgElevation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m3.302 20.071 5.729-8h5.03l6.72-7.844v15.844zm.894-5.113L3 14.096 7.079 8.38h5.04L16.723 3l1.135.983-5.07 5.896h-4.96zm2.035 3.613h13.05v-10.3l-4.55 5.3H9.78z"
  })));
};
export default SvgElevation;